import { Modal, Form, Input } from "antd";
import React, { FC, useCallback, useEffect, useState } from "react";
import * as Yup from "yup";
import axios, { AxiosError, AxiosResponse } from "axios";
import { IActivity } from "../../../../components/ProjectActions/ProposalModal";
import FormItem from "../../../../components/FormItem";
import api from "../../../../services/api";
import getValidationErrors from "../../../../utils/getValidationErrors";
import { useToast } from "../../../../hooks/toast";
import { removeEmptyKeys } from "../../../../utils/formatters";

const { TextArea } = Input;

interface IHoursModal {
  visible: boolean;
  handleClose: (activity?: IActivity) => void;
  activity?: IActivity;
}

interface IFormData {
  hours: number;
  comment_estimator: string;
}

const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 16 },
};

const HoursModal: FC<IHoursModal> = ({ visible, handleClose, activity }) => {
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});

  const [form] = Form.useForm();
  const { addToast } = useToast();

  useEffect(() => {
    if (visible) {
      form.setFieldsValue({ hours: "", comment_estimator: "" });
    }
  }, [activity, visible, form]);
  const closeModal = useCallback(
    (act?: IActivity) => {
      handleClose(act);
      setValidationErrors({});
    },
    [handleClose],
  );
  const generateErrorToast = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    (_: AxiosResponse | undefined) => {
      /* let description;

      switch (response?.status) {
        case 405:
          description = "O projeto não foi encontrado";
          break;
        case 404:
          description = "A atividade não foi encontrada";
          break;
        case 403:
          description =
            "A atividade só pode ser concluida pelo usuário atribuído";
          break;
        default:
          description =
            "Um erro occoreu ao concluir a atividade, tente novamente";
      } */

      addToast({
        type: "error",
        title: "Erro ao Estimar Horas",
        description: "Um erro ocoreu ao estimar a atividade, tente novamente",
      });
    },
    [addToast],
  );
  const handleSubmit = useCallback(
    async (formData: IFormData) => {
      const data = removeEmptyKeys(formData);
      setLoading(true);
      try {
        const schema = Yup.object().shape({
          hours: Yup.number().required(
            "Horas é obrigatório / precisa ser um número",
          ),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        const { hours, comment_estimator } = data;

        const payload = {
          hours,
          project_id: activity?.project_id,
          comment_estimator,
        };

        const response = await api.patch(
          `/activities/${activity?.id}/factory`,
          payload,
        );

        closeModal(response.data);
      } catch (err) {
        console.log(err);
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          setValidationErrors(errors);
        }
        if (axios.isAxiosError(err)) {
          const serverError = err as AxiosError;
          generateErrorToast(serverError.response);
        }
      }
      setLoading(false);
    },
    [activity, closeModal],
  );
  return (
    <Modal
      title={`Estimar Horas para a ${activity?.description}`}
      visible={visible}
      onCancel={() => closeModal()}
      width={600}
      onOk={() => form.submit()}
      okButtonProps={{
        htmlType: "submit",
        loading,
      }}
      getContainer={false}
      forceRender
      destroyOnClose
    >
      <Form {...layout} form={form} onFinish={handleSubmit}>
        <FormItem label="Horas" name="hours" errors={validationErrors} required>
          <Input type="number" />
        </FormItem>
        <FormItem
          label="Descrição"
          name="comment_estimator"
          errors={validationErrors}
        >
          <TextArea />
        </FormItem>
      </Form>
    </Modal>
  );
};

export default HoursModal;
